import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import { Field, FieldConfig } from 'formik';

import ColorPicker from './ColorPicker';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      marginTop: -1 * theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit * 2,
    },
  });

const messages = defineMessages({
  primaryMain: {
    id: 'components.v2.FieldTheme.primaryMain',
    defaultMessage: 'Primary',
  },
  secondaryMain: {
    id: 'components.v2.FieldTheme.secondaryMain',
    defaultMessage: 'Secondary',
  },
  textPrimary: {
    id: 'components.v2.FieldTheme.textPrimary',
    defaultMessage: 'Text',
  },
});

export interface FieldThemeProps extends FieldConfig<Partial<Theme>>, WithStyles<typeof styles> {}

const FieldTheme: React.FC<FieldThemeProps> = ({ classes, name, value, ...rest }) => {
  const { formatMessage } = useIntl();

  // TODO: Skip hardcoded colors once we've them set in the DB
  // NOTE: Don't import the ones from the `muiThemeLuma` since LumaBot uses different default colors
  return (
    <div className={classes.root}>
      <Field name={`${name}.palette.primary.main`} {...rest}>
        {({ field, form }: any) => (
          <ColorPicker
            label={formatMessage(messages.primaryMain)}
            value={field.value || '#0078BD'}
            onChange={(newValue) => form.setFieldValue(field.name, newValue)}
          />
        )}
      </Field>
      <Field name={`${name}.palette.secondary.main`} {...rest}>
        {({ field, form }: any) => (
          <ColorPicker
            label={formatMessage(messages.secondaryMain)}
            value={field.value || '#E9EFF0'}
            onChange={(newValue) => form.setFieldValue(field.name, newValue)}
          />
        )}
      </Field>
      <Field name={`${name}.palette.text.primary`} {...rest}>
        {({ field, form }: any) => (
          <ColorPicker
            label={formatMessage(messages.textPrimary)}
            value={field.value || '#182538'}
            onChange={(newValue) => form.setFieldValue(field.name, newValue)}
          />
        )}
      </Field>
    </div>
  );
};

export default withStyles(styles)(FieldTheme);
